{
  "credential": {
    "enter": "Enter your {label}",
    "update": "Update your {label}",
    "masked_placeholder": "***********",
    "woocommerce_api_key": {
      "label": "WooCommerce API Key",
      "placeholder": "Your WooCommerce API Key"
    },
    "woocommerce_api_secret": {
      "label": "WooCommerce API Secret",
      "placeholder": "Your WooCommerce API Secret"
    },
    "basic_auth_username": {
      "label": "Basic Authentication Username",
      "placeholder": "username (optional)"
    },
    "basic_auth_password": {
      "label": "Basic Authentication Password",
      "placeholder": "password (optional)"
    },
    "consumer_key": {
      "label": "Consumer Key",
      "placeholder": "Consumer Key"
    },
    "consumer_secret": {
      "label": "Consumer Secret",
      "placeholder": "Consumer Secret"
    },
    "access_token": {
      "label": "Access Token",
      "placeholder": "Access Token"
    },
    "access_token_secret": {
      "label": "Access Token Secret",
      "placeholder": "Access Token Secret"
    }
  },
  "store_id": {
    "label_shopify": "Enter your Shopify store name",
    "label_bigcommerce": "Enter your BigCommerce store hash",
    "label_wix": "Enter your Wix Site ID",
    "label_woocommerce": "Enter your store URL",
    "label_magento": "Enter your store URL",
    "helper_find": "You can find this by logging into your {platform} admin and looking in the browser's address bar.",
    "helper_example_shopify": "For example, if the URL is <url/>, your store name is <id/>",
    "helper_example_bigcommerce": "For example, if the URL is <url/>, your store hash is <id/>",
    "helper_example_wix": "For example, if the URL is <url/>, your Site ID is <id/>",
    "helper_redirect": "When you click Save, you'll be redirected to {platform} to authorise the SparkLayer {platform} app.",
    "magento_helper": "If you are using a development/staging domain, this can be updated when you go live"
  }
}
